<template>
    <div class="header" @touchmove.prevent>
        <div class="title">
          <div class="title-back" v-if="isBack" @click.stop="goBack">
            <i class="iconfont icon-Icon_Back_40" style="font-size:0.4rem;font-weight: normal;color:#9599A4"></i>
          </div>
          <div class="title-text">
              {{ transHeader }}
              <div v-if="country=='ke'" class="tax-free">Bet Sports. Win Tax-Free!</div>
          </div>
        </div>
        <div class="close" @click.stop="goClose">
            <i class="iconfont icon-Icon_Close_40" style="font-size:0.4rem;font-weight: normal;color:#6A6F7A"></i> 
        </div>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
    name:"Header",
    props: {
        title:{
            type:String,
            default:"",
        },
        isBack:{
           type:Boolean,
           default:false
        }
    },
    computed: {
      ...mapGetters(['country']),
      transHeader(){
        if(this.title == "Withdraw" || this.title =="Deposit"){
          const trans = this.$t("str." + this.title);
            if (trans == "str." + this.title) {
                return this.title;
            } else {
                return trans;
            }
        } else {
            return this.title;
        }
      }
    },
    watch:{

    },
    beforeDestroy() {

    },
    methods: {
        goBack(){
            this.$router.go(-1);
        },
        goClose(){
            window.googleEvent && window.googleEvent("paymentui", "Deposit_Page_Close", 0);
            let islanding = localStorage.getItem("isLanding");
            if(islanding){
              localStorage.removeItem("isLanding");
              let url = window.location.origin
              window.location.href = url
            } else {
              this.$emit("onClose");
            }
           
        }
    },
};
</script>

<style scoped  lang="scss">
.header {
  position:relative;
  margin: 0 auto;
  height: 0.88rem;
  padding: 0 0.32rem;
  font-size: .36rem;
  font-weight: bold;
  color: #292A33;
  line-height: 0.48rem;
  display: flex;
  justify-content:space-between;
  align-items:center;
  background-color: $pageBgColor;
}

.title {
  text-align:left;
  height: 1rem;
  width: 86%;
  line-height: 1rem;

  .title-back {
    float: left;
    margin-right:0.38rem;
    height: 1rem;
    line-height: 1rem;  
  }

  .title-text{
    float: left;
    display: flex;
    align-items: center;
  }

}
.tax-free{
  font-weight: normal;
  font-size: 22px;
  color: #FF8800;
  line-height: 28px;
  height: 28px;
  margin-left: 12px;
  padding-left: 106px;
  font-style: italic;
  background: linear-gradient( 90deg, #FAE8D4 0%, rgba(250,232,212,0) 100%);
  position: relative;
  &::before{
    content: "";
    background: url('~@/assets/images/Img_TaxFreeTag_28.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: absolute;
    width: 98px;
    height: 28px;
    left: 0;
  }
}
.close {
  width: 40px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Header/index.vue